import * as Sentry from '@sentry/angular';
import { LogContext, LogMessage } from '../shared/model/logs.model';

export class LoggerService {
  private logContext: LogContext;

  constructor(context: string) {
    this.logContext = new LogContext(context);

    this.error = this.error.bind(this);
    this.warn = this.warn.bind(this);
    this.info = this.info.bind(this);
  }

  error(logMessage: LogMessage) {
    logMessage.severity = 'error';

    this.log(logMessage);
  }

  warn(logMessage: LogMessage) {
    logMessage.severity = 'warn';

    this.log(logMessage);
  }

  info(logMessage: LogMessage) {
    logMessage.severity = 'info';

    this.log(logMessage);
  }

  private log(logMessage: LogMessage) {
    logMessage.context = this.logContext ?? new LogContext(LoggerService.name);

    Sentry.logger[logMessage.severity!](
      Sentry.logger.fmt`${logMessage.message}`,
      {
        context: logMessage.context.context,
        severity: logMessage.severity,
        method: logMessage.method + '()',
        identifier: logMessage.identifier,
        message: logMessage.message,
        value: logMessage.value,
      },
    );
  }
}
